import request from '@/utils/request';

function result(response) {
  if (!response || !response.data || Number(response.data.code) !== 200) {
    throw new Error((response && response.data && response.data.message) || '飞书授权操作失败');
  }
  return response.data.data;
}

export function getFeishuAuthorization() {
  return request({ url: '/admin/feishu_authorization', method: 'get' }).then(result);
}

export function beginFeishuAuthorization() {
  return request({ url: '/admin/feishu_authorization/authorize', method: 'post' }).then(result);
}

export function completeFeishuAuthorization(state) {
  return request({ url: '/admin/feishu_authorization/complete', method: 'post', data: { state } }).then(result);
}

export function unlinkFeishuAuthorization() {
  return request({ url: '/admin/feishu_authorization', method: 'delete' }).then(result);
}
